<template>
  <div class="product-options-list">
    <div class="h6 cl-bg-tertiary pt5 options">
      <custom-option v-for="option in options"
                     :key="option.sku"
                     :option="option"
                     :display-name="option.display_name"
      />
    </div>
  </div>
</template>
<script>
  import CustomOption from './CustomOption'

  export default {
    name: 'CustomOptionsList',
    components: {
      CustomOption
    },
    props: {
      selectedOptions: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        displayedNamesFor: []
      }
    },
    computed: {
      options () {
        return this.selectedOptions.map(option => {
          let isDisplayed = this.displayedNamesFor.find(name => name.value === option.name)
          if (!isDisplayed) {
            this.displayedNamesFor.push({value: option.name})
            option['display_name'] = true
          } else {
            option['display_name'] = false
          }
          return option
        })
      }
    }
  }
</script>
